<template>
  <div class="file-message message-component" @click="handleFileClick">
    <div class="file-info-content">
      <img class="file-icon" :src="fileTypeIcon" alt="" />
      <div class="file-info">
        <p class="file-name">{{ showContext.name }}</p>
        <p class="file-size">
          {{ showContext.size }}
          <template v-if="isElectron && isDownloading && message.flow === 'in'">
            <span class="fail-text" v-if="isDownloadFailed">下载失败</span>
            <span v-else>正在下载{{ downloadSpeed }}</span>
          </template>
          <template v-if="!isElectron">
            <!-- Web下载进度显示 -->
            <span
              v-if="isWebDownloading"
              class="web-download-progress file-size"
              >正在下载 {{ webDownloadSpeed }}</span
            >
            <!-- Web下载失败 -->
            <span v-else-if="isWebDownloadFailed" class="fail-text"
              >下载失败</span
            >
          </template>
        </p>
      </div>
    </div>
    <div v-if="isElectron && message.flow === 'in'" class="operation-buttons">
      <template v-if="isDownloading">
        <button v-if="isDownloadFailed" @click.stop="reFileDownload">
          <img src="../../../assets/images/live-chat/refresh-icon.png" alt="" />
        </button>
        <button v-else @click.stop="cancelFileDownload">
          <img src="../../../assets/images/live-chat/cancel-icon.png" alt="" />
        </button>
      </template>
      <button v-if="!isDownloaded && !isDownloading">
        <img src="../../../assets/images/live-chat/download-icon.png" alt="" />
      </button>
    </div>
    <!-- Web下载操作按钮 -->
    <div
      v-if="!isElectron && (isWebDownloading || isWebDownloadFailed)"
      class="web-operation-buttons"
    >
      <template v-if="isWebDownloading">
        <button @click.stop="cancelWebDownload">
          <img src="../../../assets/images/live-chat/cancel-icon.png" alt="" />
        </button>
      </template>
      <template v-if="isWebDownloadFailed">
        <button @click.stop="reWebDownload">
          <img src="../../../assets/images/live-chat/refresh-icon.png" alt="" />
        </button>
      </template>
    </div>
    <el-progress
      v-if="isElectron && isDownloading && message.flow === 'in'"
      class="file-download-progress"
      color="#00EB81"
      :percentage="downloadProgress"
      :stroke-width="4"
      :show-text="false"
    ></el-progress>
    <!-- Web下载进度条 -->
    <el-progress
      v-if="!isElectron && isWebDownloading"
      class="file-download-progress"
      color="#00EB81"
      :percentage="webDownloadProgress"
      :stroke-width="4"
      :show-text="false"
    ></el-progress>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
import { handleImageUrl } from "@saas/components/src";
import { fileImagebyFileName } from "@saas/components";
export default {
  data() {
    return {
      isElectron: window.isElectron,
    };
  },
  props: {
    showContext: {
      type: Object,
      default: () => ({}),
    },
    message: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState("newChat", [
      "defaultDownloadPath",
      "downloadInfo",
      "downloadedFileList",
    ]),
    ...mapGetters("newChat", [
      "getWebDownloadInfo",
      "getWebDownloadProgress",
      "getWebDownloadSpeed",
      "getWebDownloadController",
      "getWebDownloadReader",
      "getWebDownloadFailed",
    ]),
    fileTypeIcon() {
      const name = this.showContext.name;
      return fileImagebyFileName(name);
    },
    downloadProgress() {
      const progress = this.downloadInfo?.[this.message.ID]?.progress || 0;
      return Number((progress * 100).toFixed(2));
    },
    isDownloaded() {
      return (this.downloadedFileList || []).includes(this.showContext.name);
    },
    isDownloading() {
      return this.downloadInfo?.[this.message.ID];
    },
    downloadSpeed() {
      return (
        this.handleDownloadSpeed(
          this.downloadInfo?.[this.message.ID]?.downloadSpeed || 0
        ) || "0KB/S"
      );
    },
    isDownloadFailed() {
      return this.downloadInfo?.[this.message.ID]?.cancelled;
    },
    // Web下载相关计算属性
    webDownloadProgress() {
      return this.getWebDownloadProgress(this.message.ID);
    },
    webDownloadSpeed() {
      return this.getWebDownloadSpeed(this.message.ID);
    },
    isWebDownloading() {
      const downloadInfo = this.getWebDownloadInfo(this.message.ID);
      return (
        downloadInfo &&
        downloadInfo.progress > 0 &&
        downloadInfo.progress < 100 &&
        !downloadInfo.failed
      );
    },
    // 检查文件是否在下载队列中（包括已完成和进行中）
    isFileInDownloadQueue() {
      return !!this.getWebDownloadInfo(this.message.ID);
    },
    // Web下载失败状态
    isWebDownloadFailed() {
      return this.getWebDownloadFailed(this.message.ID);
    },
  },
  methods: {
    ...mapMutations("newChat", ["DELETE_DOWNLOAD_INFO"]),

    // 检查现有下载状态
    checkExistingDownload() {
      const downloadInfo = this.getWebDownloadInfo(this.message.ID);
      const controller = this.getWebDownloadController(this.message.ID);
      const reader = this.getWebDownloadReader(this.message.ID);

      if (downloadInfo) {
        console.log(
          `文件 ${downloadInfo.fileName} 已在下载队列中，进度: ${downloadInfo.progress}%`
        );

        // 如果下载已完成，延迟清理状态
        if (downloadInfo.progress >= 100) {
          console.log(`文件 ${downloadInfo.fileName} 下载已完成，延迟清理状态`);
          setTimeout(() => {
            this.cleanupDownload();
          }, 1000);
        }
        // 如果下载失败，显示失败状态
        else if (downloadInfo.failed) {
          console.log(
            `文件 ${downloadInfo.fileName} 下载失败，错误: ${downloadInfo.error}`
          );
        }
        // 如果下载状态异常（进度为0且速度为0），清理状态
        else if (
          downloadInfo.progress === 0 &&
          downloadInfo.speed === "0KB/s"
        ) {
          console.log(`文件 ${downloadInfo.fileName} 下载状态异常，清理状态`);
          this.cleanupDownload();
        }
        // 如果正在下载中，显示状态
        else if (downloadInfo.progress > 0 && downloadInfo.progress < 100) {
          console.log(
            `文件 ${downloadInfo.fileName} 正在下载中，进度: ${downloadInfo.progress}%`
          );

          // 检查是否有控制器和读取器，如果没有说明下载可能中断了
          if (!controller || !reader) {
            console.warn(
              `文件 ${downloadInfo.fileName} 下载资源丢失，清理状态`
            );
            this.cleanupDownload();
          }
        }
      }
    },

    reFileDownload() {
      this.DELETE_DOWNLOAD_INFO(this.message.ID);
      this.electronDownload();
    },
    // Web重新下载
    reWebDownload() {
      // 清理失败状态
      this.cleanupDownload();

      // 重新开始下载
      this.webDownload(
        handleImageUrl(this.showContext.url),
        this.showContext.name
      );
    },
    handleDownloadSpeed(speed) {
      if (speed > 1024) {
        return `${(speed / 1024).toFixed(2)}MB/s`;
      } else {
        return `${speed}KB/s`;
      }
    },
    cancelFileDownload() {
      if (window?.LiveElectronApi?.cancelFileDownload) {
        window.LiveElectronApi.cancelFileDownload({
          file_id: this.showContext.file_id,
        });
      }
    },
    handleFileClick() {
      if (!this.showContext?.url) {
        return;
      }

      if (window.isElectron) {
        if (this.message.flow === "out") {
          // 另存为
          this.electronDownload(3);
        } else {
          if (this.isDownloaded) {
            return;
          }
          if (this.isDownloading) {
            return;
          }
          this.electronDownload();
        }
      } else {
        // Web端：如果正在下载，直接忽略点击
        const downloadInfo = this.getWebDownloadInfo(this.message.ID);
        if (
          downloadInfo &&
          downloadInfo.progress > 0 &&
          downloadInfo.progress < 100
        ) {
          console.log(
            `文件 ${this.showContext.name} 正在下载中，进度: ${downloadInfo.progress}%，忽略点击`
          );
          return;
        }

        // Web端下载
        this.webDownload(
          handleImageUrl(this.showContext.url),
          this.showContext.name
        );
      }
    },
    webDownload(url, fileName) {
      // 清理旧的下载资源
      const existingController = this.getWebDownloadController(this.message.ID);
      const existingReader = this.getWebDownloadReader(this.message.ID);

      if (existingController || existingReader) {
        console.log("清理旧的下载资源");
        if (existingController) {
          existingController.abort();
        }
        if (existingReader) {
          existingReader.cancel();
        }
        this.cleanupDownload();
      }

      // 初始化全局下载信息
      this.$store.commit("newChat/SET_WEB_DOWNLOAD_INFO", {
        messageId: this.message.ID,
        info: {
          progress: 0,
          speed: "0KB/s",
          fileName,
          url,
          failed: false,
          error: null,
        },
      });

      // 创建全局下载控制器
      const controller = new AbortController();
      this.$store.commit("newChat/SET_WEB_DOWNLOAD_CONTROLLER", {
        messageId: this.message.ID,
        controller,
      });

      // 检查浏览器是否支持 ReadableStream
      if (!window.ReadableStream) {
        this.fallbackDownload(url, fileName);
        return;
      }

      // 开始流式下载
      this.streamDownload(url, fileName, controller);
    },

    // 流式下载方法
    streamDownload(url, fileName, controller) {
      console.log(`开始流式下载: ${fileName}`);

      // 检查控制器是否已被中止
      if (controller.signal.aborted) {
        console.log("下载控制器已被中止，取消下载");
        return;
      }

      fetch(url, {
        signal: controller.signal,
        headers: {
          "Cache-Control": "no-cache",
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const contentLength = response.headers.get("content-length");
          const total = contentLength ? parseInt(contentLength, 10) : 0;
          let loaded = 0;
          const startTime = Date.now();

          // 创建 ReadableStream 用于流式处理
          const reader = response.body.getReader();
          this.$store.commit("newChat/SET_WEB_DOWNLOAD_READER", {
            messageId: this.message.ID,
            reader,
          });

          const chunks = [];

          return new Promise((resolve, reject) => {
            const pump = () => {
              reader
                .read()
                .then(({ done, value }) => {
                  if (done) {
                    // 下载完成，合并所有chunks
                    const blob = new Blob(chunks);
                    resolve(blob);
                    return;
                  }

                  chunks.push(value);
                  loaded += value.length;

                  // 计算下载速度
                  const currentTime = Date.now();
                  const elapsedTime = (currentTime - startTime) / 1000;
                  let speed = "0KB/s";
                  if (elapsedTime > 0) {
                    const speedKBps = loaded / 1024 / elapsedTime;
                    speed =
                      speedKBps > 1024
                        ? `${(speedKBps / 1024).toFixed(2)}MB/s`
                        : `${speedKBps.toFixed(0)}KB/s`;
                  }

                  // 计算进度
                  const progress =
                    total > 0
                      ? (loaded / total) * 100
                      : Math.min((loaded / (1024 * 1024)) * 10, 95);

                  // 更新全局状态
                  this.$store.commit("newChat/SET_WEB_DOWNLOAD_INFO", {
                    messageId: this.message.ID,
                    info: {
                      progress,
                      speed,
                      loadedBytes: loaded,
                    },
                  });

                  // 继续读取
                  pump();
                })
                .catch(reject);
            };

            pump();
          });
        })
        .then((blob) => {
          // 下载完成，触发文件保存
          this.saveFile(blob, fileName);

          // 更新下载状态为完成
          this.$store.commit("newChat/SET_WEB_DOWNLOAD_INFO", {
            messageId: this.message.ID,
            info: {
              progress: 100,
              speed: "下载完成",
            },
          });

          // 延迟清理状态
          setTimeout(() => {
            this.cleanupDownload();
          }, 2000);
        })
        .catch((error) => {
          if (error.name === "AbortError") {
            console.log("下载已取消");
            this.cleanupDownload();
          } else {
            console.error("下载失败:", error);
            // this.$message.error("下载失败，请重试");

            // 设置下载失败状态
            this.$store.commit("newChat/SET_WEB_DOWNLOAD_INFO", {
              messageId: this.message.ID,
              info: {
                failed: true,
                error: error.message,
                speed: "下载失败",
              },
            });
          }
        });
    },

    // 备用下载方法
    fallbackDownload(url, fileName) {
      // this.$message.info("正在下载文件...");

      fetch(url)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.blob();
        })
        .then((blob) => {
          this.saveFile(blob, fileName);
          // this.$message.success("下载完成");

          // 更新下载状态为完成
          this.$store.commit("newChat/SET_WEB_DOWNLOAD_INFO", {
            messageId: this.message.ID,
            info: {
              progress: 100,
              speed: "下载完成",
            },
          });

          // 延迟清理状态
          setTimeout(() => {
            this.cleanupDownload();
          }, 2000);
        })
        .catch((error) => {
          console.error("下载失败:", error);
          // this.$message.error("下载失败，请重试");

          // 设置下载失败状态
          this.$store.commit("newChat/SET_WEB_DOWNLOAD_INFO", {
            messageId: this.message.ID,
            info: {
              failed: true,
              error: error.message,
              speed: "下载失败",
            },
          });
        });
    },

    // 保存文件到本地
    saveFile(blob, fileName) {
      try {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      } catch (error) {
        console.error("保存文件失败:", error);
        this.$darkMessage.error("保存文件失败");
      }
    },

    // 清理下载状态
    cleanupDownload() {
      console.log(`清理下载状态: ${this.message.ID}`);

      // 先获取并清理旧的资源
      const existingController = this.getWebDownloadController(this.message.ID);
      const existingReader = this.getWebDownloadReader(this.message.ID);

      if (existingController) {
        try {
          existingController.abort();
          console.log("已中止旧的下载控制器");
        } catch (error) {
          console.warn("中止下载控制器时出错:", error);
        }
      }

      if (existingReader) {
        try {
          existingReader.cancel();
          console.log("已取消旧的下载读取器");
        } catch (error) {
          console.warn("取消下载读取器时出错:", error);
        }
      }

      // 清理全局状态
      this.$store.commit("newChat/DELETE_WEB_DOWNLOAD_INFO", this.message.ID);
      this.$store.commit(
        "newChat/DELETE_WEB_DOWNLOAD_CONTROLLER",
        this.message.ID
      );
      this.$store.commit("newChat/DELETE_WEB_DOWNLOAD_READER", this.message.ID);

      console.log("下载状态清理完成");
    },

    // 取消Web下载
    cancelWebDownload() {
      console.log(`用户取消下载: ${this.message.ID}`);

      // 获取全局控制器和读取器
      const controller = this.getWebDownloadController(this.message.ID);
      const reader = this.getWebDownloadReader(this.message.ID);

      // 取消下载
      if (controller) {
        try {
          controller.abort();
          console.log("已中止下载控制器");
        } catch (error) {
          console.warn("中止下载控制器时出错:", error);
        }
      }

      if (reader) {
        try {
          reader.cancel();
          console.log("已取消下载读取器");
        } catch (error) {
          console.warn("取消下载读取器时出错:", error);
        }
      }

      // 清理状态
      this.cleanupDownload();
    },

    electronDownload(openType) {
      let { url, file_id, name, date } = this.showContext;
      if (window.LiveElectronApi) {
        const params = {
          fileUrl: handleImageUrl(url),
          file_id,
          file_path: this.defaultDownloadPath + name,
          date,
          file_name: name,
          im_msg_key: this.message.ID,
          winKey: "custom-live-room",
        }
        if (openType) {
          // 3 另存为
          params.openType = 3;
          params.needGetFileCosUrl = false;
        } 
        window.LiveElectronApi?.openOrDownloadFile(params);
      }
      console.log("==zy==electronDownload", this.showContext);
    },
    download({ url, name }) {
      url = handleImageUrl(this.showContext.url);
      const option = {
        mode: "cors",
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded",
        }),
      };
      if (window.fetch) {
        fetch(url, option)
          .then((res) => res.blob())
          .then((blob) => {
            const a = document.createElement("a");
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = name;
            a.click();
          });
      } else {
        const a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.download = name;
        a.click();
      }
    },
  },
  watch: {
    // 监听消息ID变化，重新检查下载状态
    "message.ID": {
      handler(newId, oldId) {
        if (newId !== oldId) {
          this.checkExistingDownload();
        }
      },
      immediate: true,
    },
  },
  mounted() {},
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.file-message {
  position: relative;
  width: 240px;
  height: 64px;
  background: #27272a;
  border-radius: 8px 8px 8px 8px;
  padding: 10px 10px 0 10px;
  overflow: hidden;

  .file-download-progress {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }

  .fail-text {
    color: #ff265c;
  }

  .operation-buttons {
    position: absolute;
    bottom: 8px;
    right: 4px;
    button {
      width: 18px;
      height: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .web-operation-buttons {
    position: absolute;
    bottom: 8px;
    right: 4px;
    button {
      width: 18px;
      height: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: none;
      border: none;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .file-info-content {
    display: flex;
    align-items: center;
  }
  .file-icon {
    width: 34px;
    height: 34px;
    margin-right: 12px;
  }
  .file-info {
    flex: 1;
    width: 0;
    .file-name {
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      line-height: 16px;
      margin-bottom: 8px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .file-size {
      font-weight: 400;
      font-size: 11px;
      color: #86909c;
    }
  }
}
</style>
